import { Loader } from "@dbn/omnichannel-design-system-g4p";
import { option } from "fp-ts";
import { pipe, constNull, constant } from "fp-ts/function";
import { Option } from "fp-ts/Option";
import {
  DropdownField,
  DropdownFieldProps,
} from "../../Common/DropdownField/DropdownField";
import { useQuery } from "../../useAPI";
import * as api from "../api";
import * as remoteData from "../../RemoteData";
import { optionFromArrayKey, optionsFromArray } from "./utils";
import { RuntimeLocaleKey, useFormatMessage } from "../../intl";

type DropdownProps<T> = Omit<
  DropdownFieldProps<T>,
  "options" | "value" | "onChange"
>;

type Props<T> = DropdownProps<T> & {
  branchCode: string;
  value: Option<string>;
  onChange: (value: Option<string>) => void;
};

export function BankersDropdown(props: Props<string>) {
  const { branchCode, value, ...dropdownProps } = props;
  const formatMessage = useFormatMessage();

  const [bankersData] = useQuery(api.getBankers, {
    branchCode: props.branchCode,
  });

  return pipe(
    bankersData,
    remoteData.fold(
      constant(
        <Loader
          ariaLabelMessage={formatMessage(
            "generic.loading.alt" as RuntimeLocaleKey
          )}
        />
      ),
      constNull,
      ({ bankers }) => (
        <DropdownField
          {...dropdownProps}
          options={optionsFromArray(bankers)}
          value={pipe(value, optionFromArrayKey(bankers))}
          onChange={value =>
            pipe(
              value,
              option.map(({ value }) => value),
              dropdownProps.onChange
            )
          }
        />
      )
    )
  );
}
